import { dateTime } from "@/lib/format";

const ordinal = (n) => (n ? `${n}${["th", "st", "nd", "rd"][(n % 100 > 10 && n % 100 < 14) || n % 10 > 3 ? 0 : n % 10]}` : "—");

function Tile({ label, value, tone = "", id }) {
  return <div className={`tm-tile ${tone}`} data-testid={`team-tile-${id}`}><span>{label}</span><b>{value ?? "—"}</b></div>;
}

export function TeamHeader({ page }) {
  const { info, standing, division } = page;
  const ppg = page.season_stats.find((s) => s.key === "ppg");
  const opp = page.season_stats.find((s) => s.key === "opp_ppg");
  const divRank = standing ? division.findIndex((r) => r.team_id === standing.team_id) + 1 : null;
  const streak = standing?.streak;
  return (
    <header className="tm-head" style={{ "--team": `#${info.color || "1d428a"}` }} data-testid="team-header">
      <div className="tm-crumbs">NBA › {standing?.conference || ""} › {standing?.division || ""}</div>
      <div className="tm-head-main">
        <img className="tm-logo" src={info.logo} alt={info.code} />
        <div className="tm-title">
          <span>{info.location}</span>
          <h1 data-testid="team-name">{info.nickname}</h1>
          <p>{standing?.conference}{standing?.division ? ` | ${standing.division} Division` : ""}</p>
        </div>
        <div className="tm-tiles">
          <Tile id="record" label="Record" value={standing ? `${standing.wins} - ${standing.losses}` : info.record_summary} />
          <Tile id="conference" label="Conference" value={ordinal(standing?.seed)} />
          <Tile id="division" label="Division" value={ordinal(divRank)} />
          <Tile id="ppg" label="PPG" value={ppg?.value} />
          <Tile id="opp" label="Opp PPG" value={opp?.value} />
          <Tile id="streak" label="Streak" value={streak} tone={streak?.startsWith("W") ? "is-win" : streak?.startsWith("L") ? "is-loss" : ""} />
        </div>
      </div>
      {page.last_sync && <small className="tm-sync" data-testid="team-last-sync">Updated {dateTime(page.last_sync)} · refreshes 09:00 &amp; 18:00</small>}
    </header>
  );
}
